import React, { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();
  const loc = useLocation();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const res = await login(email, password);
    setLoading(false);
    if (res.ok) {
      toast.success(`Welcome back, ${res.user.name}`);
      const redirect = loc.state?.redirect || (res.user.role === "admin" ? "/admin" : "/account");
      nav(redirect);
    } else {
      toast.error(res.error);
    }
  };

  return (
    <div className="pt-32 pb-24 min-h-[80vh] flex items-center justify-center" data-testid="login-page">
      <motion.form
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        onSubmit={submit}
        className="glass-panel rounded-lg p-10 w-full max-w-md"
      >
        <div className="text-center mb-8">
          <div className="text-[10px] tracking-[0.35em] uppercase text-pink-blush mb-3">Welcome back</div>
          <h1 className="font-display text-4xl text-champagne">
            Sign <span className="italic text-pink-hot">in</span>
          </h1>
        </div>
        <div className="space-y-3">
          <input required type="email" placeholder="Email" value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="login-email"
            className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne" />
          <input required type="password" placeholder="Password" value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="login-password"
            className="w-full bg-noir-base border border-rosegold/20 px-4 py-3 text-sm rounded-sm focus:border-pink-hot focus:outline-none text-champagne" />
          <button
            disabled={loading}
            className="w-full py-3 bg-pink-hot text-white text-xs tracking-[0.3em] uppercase rounded-sm hover:bg-pink-glow glow-pink transition-all disabled:opacity-60"
            data-testid="login-submit"
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
        </div>
        <div className="text-right mt-2">
          <Link to="/forgot-password" className="text-xs text-pink-blush/90 hover:text-pink-hot pink-underline-link tracking-wider" data-testid="forgot-password-link">
            Forgot password?
          </Link>
        </div>
        <div className="divider-gold my-6" />
        <div className="text-center text-sm text-champagne/70">
          New here?{" "}
          <Link to="/register" className="text-pink-hot pink-underline-link" data-testid="go-register">
            Create an account
          </Link>
        </div>
      </motion.form>
    </div>
  );
}
